export default "__VITE_ASSET__Ct_YEN3x__"